import {CHANGE_IS_CLOSEABLE, CHANGE_MODAL_ANIMATION, CHANGE_MODAL_CONTENT, CHANGE_MODAL_STATE} from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export const changeModalState = (newState: "modal-display" | "modal-dismiss" | "modal-fade-in" | "modal-fade-out"): AppAction => ({
    type: CHANGE_MODAL_STATE,
    payload: {},
    value: newState
});

export const changeIsCloseable = (isCloseable: boolean): AppAction => ({
    type: CHANGE_IS_CLOSEABLE,
    payload: {},
    value: isCloseable
});

export const changeModalAnimation = (isFadeOut: boolean): AppAction => ({
    type: CHANGE_MODAL_ANIMATION,
    payload: {},
    value: isFadeOut
})

export const changeModalContent = (content?: React.ReactElement, title?: string | React.ReactElement,  contentAriaLabel?: string, crossButtonAriaLabel?: string, className?: string, translationFile?: string, titleKey?: string,  contentAriaLabelKey?: string, crossButtonAriaLabelKey?: string, isTitleCentered?: boolean): AppAction => ({
    type: CHANGE_MODAL_CONTENT,
    payload: {
        data: {
            content,
            className,
            title,
            contentAriaLabel,
            crossButtonAriaLabel,
            translationFile,
            titleKey,
            contentAriaLabelKey,
            crossButtonAriaLabelKey,
        }
    }
});